//скрипт, который автоматически собирает все роуты и модули vuex
let routes = []
let menus = {}
let toolbars = {}
let menusToSort = {}
let stores = {}
let pusher = {}
let dashboards = {}

//находим все файлы с именем routes.js в текущей папке
let files = require.context('.', true, /routes\.js$/)
files.keys().forEach(key => {
  let moduleName = key.match(/\.\/(.+?)\//)[1]
  //получаем роуты
  let moduleRoutes = files(key).default.routes
  moduleRoutes.forEach(route => {
    if (typeof route.meta == 'undefined') route.meta = {}
    route.meta.module = moduleName
  })
  routes = routes.concat(moduleRoutes)
})

//модули vuex
files = require.context('.', true, /store\.js$/)
files.keys().forEach(key => {
  //получаем название модуля
  let moduleName = key.match(/\.\/(.+?)\//)[1]
  stores[moduleName] = files(key).default.store
})



//компоненты верхней панели
files = require.context('.', true, /Dashboard/)
files.keys().forEach(key => {
  let dashboard = files(key)
  let dashboardName = key.match(/([A-Za-z]+)Dashboard/)[1]
  let moduleName = key.match(/\.\/(.+?)\//)[1]
  if (typeof dashboards[moduleName] == 'undefined') dashboards[moduleName] = {}
  dashboards[moduleName] = dashboard
})

//обработчики pusher
files = require.context('.', true, /pusher\.js$/)
files.keys().forEach(key => {
  //получаем название модуля
  let moduleName = key.match(/\.\/(.+?)\//)[1]
  pusher[moduleName] = files(key).default
})

//компоненты верхней панели
files = require.context('.', true, /Toolbar$/)
files.keys().forEach(key => {
  let toolbar = files(key)
  let toolbarName = key.match(/([A-Za-z]+)Toolbar/)[1]
  let moduleName = key.match(/\.\/(.+?)\//)[1]
  if (typeof toolbars[moduleName] == 'undefined') toolbars[moduleName] = {}
  toolbars[moduleName][toolbarName] = toolbar
})

//компоненты меню
//пользовательская сортировка
let userMenusSort = {}
userMenusSort = JSON.parse(localStorage.getItem('userMenusSort'))
if (userMenusSort == null) userMenusSort = {}
files = require.context('.', true, /Menu$/)
files.keys().forEach(key => {
  let menu = files(key)
  //получение типа меню
  let menuName = key.match(/([A-Za-z]+)Menu/)[1]
  if (typeof menusToSort[menuName] == 'undefined') menusToSort[menuName] = []
  //заменяем значение сортировки из пользовательского объекта
  if (typeof userMenusSort[menuName] != 'undefined' && typeof userMenusSort[menuName][menu.name] != 'undefined') menu.sort = userMenusSort[menuName][menu.name]
  //если значение не задано, то 100 - значение по умолчанию
  else if (typeof menu.sort == 'undefined') menu.sort = 100
  if (typeof userMenusSort[menuName] == 'undefined') userMenusSort[menuName] = {}
  userMenusSort[menuName][menu.name] = menu.sort
  menusToSort[menuName].push(menu)
})
localStorage.setItem('userMenusSort', JSON.stringify(userMenusSort))
//сортировка
for (var key in menusToSort) {
  if (!menusToSort.hasOwnProperty(key)) continue;
  var menuType = menusToSort[key];
  menuType.sort((a, b) => {
  	return a.sort - b.sort
  })
}
//формирование конечного объекта меню
for (var i in menusToSort) {
  if (!menusToSort.hasOwnProperty(i)) continue;
  var menuType = menusToSort[i];
  menuType.forEach(menu => {
    if (typeof menus[i] == 'undefined') menus[i] = {}
    menus[i][menu.name] = menu
  })
}

export { routes, stores, menus, pusher, toolbars, dashboards }



// WEBPACK FOOTER //
// ./src/modules/index.js